import { render } from "./ThanksView.vue?vue&type=template&id=2882e034"
import script from "./ThanksView.vue?vue&type=script&lang=js"
export * from "./ThanksView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__